import { render, staticRenderFns } from "./joingroup.vue?vue&type=template&id=4040f6c0&scoped=true&"
import script from "./joingroup.vue?vue&type=script&lang=js&"
export * from "./joingroup.vue?vue&type=script&lang=js&"
import style0 from "./joingroup.vue?vue&type=style&index=0&id=4040f6c0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4040f6c0",
  null
  
)

export default component.exports